import { create } from 'zustand';

type State = {
  openModalTimeout: boolean
  isActivity: boolean
}

type Action = {
  clearAuthStore: () => void
  setOpenModalTimeout: (openModal: boolean) => void
  setIsActivity: (activity: boolean) => void
}

export const useAuthStore = create<State & Action>((set) => ({
  openModalTimeout: false,
  isActivity: true,
  setOpenModalTimeout: (openModal: boolean) =>
    set(() => ({ openModalTimeout: openModal })),
  setIsActivity: (activity: boolean) =>
    set(() => ({ isActivity: activity })),
  clearAuthStore: () =>
    set({
      openModalTimeout: false
    })
}));
